import * as React from 'react';
import { type ReactElement } from 'react';
import { Icon } from '../Icon/Icon';
import type { SearchResult } from './Types';

export interface IQuickSearchPopupProp {
    searchtext: string;
    items?: SearchResult[];
    numberOfItemsToShow: number;
    querySearchUrl: string;
    hide: boolean;
    activeItem: number;
}

export class QuickSearchPopup extends React.Component<IQuickSearchPopupProp> {
    constructor(props: IQuickSearchPopupProp) {
        super(props);
    }

    render(): ReactElement {
        if (this.props.searchtext.trim().length === 0 || this.props.hide) {
            return null;
        }

        return <div>{this.props.items?.length > 0 ? this.renderItems() : this.renderEmptyResult()}</div>;
    }

    private renderItems() {
        return (
            <div>
                <hr />
                <ul>
                    {this.props.items.slice(0, this.props.numberOfItemsToShow).map(this.renderItem.bind(this))}
                    {this.props.items.length > this.props.numberOfItemsToShow && this.renderMoreHitsLink()}
                </ul>
            </div>
        );
    }

    private renderMoreHitsLink() {
        const index = this.props.numberOfItemsToShow;

        return (
            <li key={index} className={this.props.activeItem === index ? 'active' : ''}>
                <a href={this.props.querySearchUrl} className="quick-search-info__more-results-link">
                    <div className="quick-search-info__list-item align-items-center justify-content-center">
                        <span>Visa fler träffar</span>
                    </div>
                </a>
            </li>
        );
    }

    private renderItem(item: SearchResult, index: number): JSX.Element {
        return (
            <li key={index} className={this.props.activeItem === index ? 'active' : ''}>
                <a href={item.url}>
                    <div className="quick-search-info__list-item align-items-center">
                        <div className="quick-search-info__list-item-icon">{item.iconId && this.renderIcon(item.iconId)}</div>
                        <div className="quick-search-info__list-item-content">
                            <div className="quick-search-info__item-content-type" dangerouslySetInnerHTML={{ __html: item.displayName }} />
                            <div className="quick-search-info__item-content-title" dangerouslySetInnerHTML={{ __html: item.title }} />
                        </div>
                    </div>
                </a>
            </li>
        );
    }

    private renderIcon(iconId) {
        return <Icon symbol={iconId} />;
    }

    private renderExcerpt(excerpt) {
        return (
            <div className="search-info__item-content-description">
                <sub dangerouslySetInnerHTML={{ __html: excerpt }} />
            </div>
        );
    }

    private renderEmptyResult() {
        return (
            <div>
                <hr />
                <ul>
                    <li>Kan inte hitta några resultat för sökordet...</li>
                </ul>
            </div>
        );
    }
}
